import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaQuestionPopupComponent } from './viva-question-popup.component';

@NgModule({
  declarations: [
    VivaQuestionPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaQuestionPopupComponent
  ]
})
export class  VivaQuestionPopupModule { }
